import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1 whitespace-nowrap">
            {index > 0 && (
              <span className="text-foreground-300 mx-0.5">/</span>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}